import { Contact, CustomerType } from '@api/generated/graphql';
import {
  FormAddressType,
  defaultAddress,
} from '@components/forms/components/AddressFormManager/components/AddressForm/AddressFormDefinitions';
import { defaultContacts } from '@components/forms/components/ContactMethodForm';
import { AnvilSelectOptionsProps } from '@servicetitan/design-system';
import strings from './strings';
import { Definite } from '@lib/utils/utilityTypes';

export const createCustomerInitialValues: CreateCustomerFormValues = {
  type: CustomerType.Residential,
  customer: {
    name: '',
    address: defaultAddress,
    contacts: defaultContacts,
  },
  user: {
    address: defaultAddress,
  },
  payee: 'customer',
  billingCustomer: {
    name: '',
    address: defaultAddress,
    contacts: defaultContacts,
  },
};

export type CustomerFormPrefixes =
  | 'customer'
  | 'billingCustomer'
  | 'user'
  | 'e911';
export type PayeeType = 'customer' | 'billingCustomer';

export type ContactMethodType = Definite<Omit<Contact, 'id' | '__typename'>>;

export interface CreateCustomerFormValues {
  type: CustomerType;
  customer: {
    name: string;
    address: FormAddressType;
    contacts: ContactMethodType[];
  };
  user?: {
    name?: string;
    address: FormAddressType;
    contacts?: ContactMethodType[];
  };
  e911?: {
    name?: string;
    address: FormAddressType;
    contacts?: ContactMethodType[];
  };
  payee: PayeeType;
  billingCustomer?: {
    name: string;
    address: FormAddressType;
    contacts: ContactMethodType[];
  };
}

export interface CreateCustomerFormProps {
  onSubmit: () => void;
}

export const payeeOptions: AnvilSelectOptionsProps[] = [
  {
    text: strings.labels.customerPayeeOption,
    value: 'customer',
  },
  {
    text: strings.labels.billingCustomerPayeeOption,
    value: 'billingCustomer',
  },
];
